<div class="div-title">
  <h1 mat-dialog-title>
    {{ data.title }}
  </h1>
  <mat-icon [class.icon-title]="true" [class.blue-color]="iconColor === 'blue'" [class.red-color]="iconColor === 'red'" [class.green-color]="iconColor === 'green'" *ngIf="iconTitle" class="icon-title"> {{ iconTitle }} </mat-icon>
</div>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div class="div-buttons" mat-dialog-actions>
  <button mat-button mat-raised-button mat-dialog-close>{{ data.buttonText }}</button>
  <button *ngIf="data.secondButtonText !== ''" color="primary" mat-button mat-raised-button [mat-dialog-close]="true">{{ data.secondButtonText }}</button>
</div>
